import React from "react"
import { graphql } from "gatsby"
import { Typography } from "antd"
import Layout from "../../../components/Layout"
import "../../../styles/odooServices.scss"
import "../../../styles/services.scss"
import "../../../styles/caseStudy.scss"
import News from "../../../components/News"
import ProductTopSection from "../../../components/ProductTopSelection"
import ServiceCard from "../../../components/ServiceCard"
import Wethoughtyoumighthavequestions from "../../../components/Wethoughtyoumighthavequestions"
import CaseStudeiesSimplified from "../../../components/CaseStudeiesSimplified"
import ImageWithTextSection from "../../../components/ImageWithTextSection"
import IconsAdded from "../../../components/IconsAdded"
import sc_performance from "../../../images/servicecard/performance.png"
import sc_cloud from "../../../images/servicecard/cloud.png"
import sc_integration from "../../../images/servicecard/integration.png"
import sc_testing from "../../../images/servicecard/Automated testing.png"

const { Title } = Typography
const MD365BulkStockDistribution = ({ data }) => {
  return (
    <div className="CaseStudeies">
      <Layout pageTitle={"Visiomate - Microsoft Dynamics 365 Distribution Utility"}
      descrip = {"Transform your distribution and utility business with the power of Dynamics 365. Gain real-time insights, improve efficiency, and drive growth. Explore now!"}>
        <ProductTopSection
          headerData={{
            title: "Distribution Utility: Streamline your supply chain. Bulk distribution simplified. ",
            peragraph: "A bulk distribution utility seemlessly integrated with Dynamics 365. Internal transfers and wholesale order creation is covered."
            // , image: headerImage
          }}
          data={data}
        />
        <div className="services-page-container position-relative">
          <div className="services-description-section">
            <div className="service-heading-and-detail">
              <Title>Bulk Distribution, Simplified at Scale</Title>
            </div>
            <div className="service-cards-wrapper">
              <ServiceCard
                img_src={sc_performance}
                img_alt="Operational Efficiency"
                card_heading="Operational Efficiency"
                card_para="Utility optimizes warehouse processes, automating routine tasks and fostering a more efficient operational environment."
              />
              <ServiceCard
                img_src={sc_cloud}
                img_alt="Optimized Inventory Control"
                card_heading="Optimized Inventory Control"
                card_para="Utility streamlines inventory distribution, reducing holding costs, and ensuring timely fulfillment of orders."
              />
              <ServiceCard
                img_src={sc_integration}
                img_alt="Holistic Data Integration"
                card_heading="Holistic Data Integration"
                card_para="Utility integrates with Dynamics 365 seamlessly, optimising the user experience with increased ease of use."
              />
              <ServiceCard
                img_src={sc_testing}
                img_alt="Time and Cost Savings"
                card_heading="Time and Cost Savings"
                card_para="Automation of tasks, such as bulk transfer and sales order creation for multiple stores and customers, saves time and reduces the need for manual labor."
              />
            </div>
          </div>
        </div>
        <ImageWithTextSection
          title="Core Distribution Features"
          caseStudyData={{
            data: [
              {
                heading: "Multiple Destination Location Selection",
                description:
                  "User can select multiple destination locations to create Transfer Order.",
              },
              {
                heading: " Continent Selection or all at once",
                description:
                  " User can use select all option by just clicking on the select all checkbox",
              },
              {
                heading: " Filter by D365 Hierarchy & Category  ",
                description:
                  "Utility provides filter options based on the D365 hierarchy & category configuration",
              },
              {
                heading: "Filter by Product & Product Dimensions ",
                description:
                  "Utility provides ability to further narrow down by selecting the desired product and product dimensions. ",
              },
              {
                heading: " Distribution Management ",
                description:
                  "User can create as many as distributions and process them later at his / her convenience.",
              },
              {
                heading: "Flexible grid view to fill up the distribution demand",
                description:
                  "User can scroll horizontally or Vertically with fixed Headers to fill up the demand with ease.",
              },
            ],
          }}
          dataFormImages={data}
          classText={"bulk-image-size"}
        />
        {/* <CaseStudeiesSimplified
          TextData={{
            title: "Simplified Steps to get you Started ",
            Data: [
              {
                peragraph: "Define Requirements",
                list: [
                  "Clearly outline your business objectives and identify the specific challenges or needs that the software solution should address.",
                  "List down the essential features and functionalities required.",
                ],
              },
              {
                peragraph: "Demo and Evaluation",
                list: [
                  "Schedule product demonstrations. ",
                  "Evaluate the software's usability, features, and performance. ",
                  "Engage key stakeholders in the evaluation process.",
                ],
              },
              {
                peragraph: "Scalability and Integration",
                list: [
                  "Identify the potential integrations required by the customer.",
                  "Plan the implementation of identified integrations.",
                ],
              },
              {
                peragraph: "UAT & User Feedback",
                list: [
                  "UAT period allows customer to assess the system performance and suitability for the specific business needs.",
                  "Customer’s insights can provide valuable perspectives on usability, functionality mismatch.",
                ],
              },
              {
                peragraph: "User Training",
                list: [
                  " User training is a critical component of successfully implementing the software solution.",
                  "Proper training ensures that users can effectively and efficiently utilize the software, maximizing its benefits.",
                ],
              },
              {
                peragraph: "Post-Implementation Support",
                list: [
                  "Provide ongoing support for users.",
                  "Address any post-implementation issues.",
                  "Evaluate and implement system enhancements based on feedback.",
                ],
              },
            ],
          }}
        /> */}
        <Wethoughtyoumighthavequestions
          data={[
            {
              question: "What exactly is the D365 Distribution Utility?",
              answer: "The Distribution Utility is a lightweight desktop application that integrates directly with Microsoft Dynamics 365 Finance & Operations. It allows warehouse teams to create bulk internal transfer orders and wholesale sales orders for multiple destinations simultaneously — without needing to log in to D365 for each one.",
            },
            {
              question: "Who benefits most from using this utility?",
              answer: "Warehouse managers, distribution coordinators, and supply chain teams who regularly process high-volume stock movements across multiple stores, regions, or customers will see the greatest impact. It eliminates repetitive manual entry inside D365.",
            },
            {
              question: "Do users need a Microsoft Dynamics 365 license to run this utility?",
              answer: "No — that's one of its key advantages. The utility operates independently of D365's licensing model. End users of the utility do not need their own D365 seats, which significantly reduces the cost of rolling it out across warehouse teams.",
            },
            {
              question: "How is the utility licensed and priced?",
              answer: "The utility is available on a one-time lifetime license for up to three users, with no recurring subscription fees. Contact us for a quote tailored to your organization's scale.",
            },
            {
              question: "Will the utility continue to work when D365 is upgraded?",
              answer: "Yes. Visiomate actively maintains the utility to stay compatible with new D365 release waves. If a D365 update introduces a breaking change, our team prioritizes a fix — because we believe in solving problems, not just selling products.",
            },
            {
              question: "How do I get started with the Distribution Utility?",
              answer: "Reach out to our team through the contact form on our website. Share your requirements and current D365 setup, and we'll walk you through a demo and licensing options within 24 hours.",
            },
          ]}
          title="We thought you might have questions"
        />
        <News isAbout={true} career={true} />
      </Layout>
    </div>
  )
}

export default MD365BulkStockDistribution
export const query = graphql`
  query MD365BulkStockDistributionImages {
    VMLogoBlack: file(relativePath: { eq: "logo_black_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    VMLogoWhite: file(relativePath: { eq: "logo_white_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    HeaderImg: file(
      relativePath: { eq: "DistributionD365/dist_top_header.png" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    markFlag: file(
      relativePath: { eq: "4879902_check_flag_mark_ok_icon_1_copy.png" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    bgImages: file(relativePath: { eq: "prodbg-01.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img1: file(relativePath: { eq: "DistributionD365/1.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img2: file(relativePath: { eq: "DistributionD365/2.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img3: file(relativePath: { eq: "DistributionD365/3.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img4: file(relativePath: { eq: "DistributionD365/4.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img5: file(relativePath: { eq: "DistributionD365/5.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    img6: file(relativePath: { eq: "DistributionD365/6.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
